import { observable } from "mobx";
import { IService, IComponent, IFullComponent } from "../_types/interfaces";
import i18n from 'i18next';
import { updateComponent } from "../_services";
import { FilterType } from "../_types/enums/FilterType";

const translate = (name: string) => i18n.t('components.notification.' + name);

export const componentStore = observable({
    loading: false,
    uriService: "",
    services: [] as Array<IComponent>,
    installService: [] as Array<IComponent>,
    plugins: [] as Array<IComponent>,
    installPlugins: [] as Array<IComponent>,
    isNotification: false,
    fullComponents: [] as Array<IFullComponent>,
    message: "",
    filter: FilterType.None,
    showMessage(message: string) {
        this.message = message;
        this.isNotification = true;
    },
    async getAddress() {
        this.loading = true;
        try {
            const response = await updateComponent.getAddress();
            this.uriService = response;
        }
        catch (errors) {
            this.showMessage(translate('load_error'));
        }
        this.loading = false;
    },
    async loadServices() {
        this.loading = true;
        try {
            const responseGetServices = 
                await updateComponent.getServices(componentStore.uriService);
            this.services = responseGetServices;
            const responseGetInstallServices = 
                await updateComponent.getInstallServices();
            this.installService = responseGetInstallServices;
        }
        catch (errors) {
            this.showMessage(translate('load_error'));
        }
        this.loading = false;
    },
    async loadPlugins() {
        this.loading = true;
        try {
            const responseGetPlugins = 
                await updateComponent.getPlugins(this.uriService);
            this.plugins = responseGetPlugins;
            const responseGetInstallPlugins = 
                await updateComponent.getInstallPlugins();
            this.installPlugins = responseGetInstallPlugins;
        }
        catch (errors) {
            this.showMessage(translate('load_error'));
        }
        this.loading = false;
    },
    async addComponents(names: Array<string>) {
        this.loading = true;
        try {
            await updateComponent.updateServices(names);
            this.showMessage(translate('add_ok'));
        }
        catch (errors) {
            console.log(errors);
            this.showMessage(translate('add_error'));
        }
        this.loading = false;
    },

    async deleteComponents(names: Array<string>) {
        this.loading = true;
        try {
            await updateComponent.deleteServices(names);
            this.showMessage(translate('delete_ok'));
        }
        catch (errors) {
            console.log(errors);
            this.showMessage(translate('delete_error'));
        }
        this.loading = false;
    },

    async loadFullComponents(servicesInstalled: Array<IService>) {
        this.loading = true;
        try {
            console.log("Start full component");

            const full = new Map<string, IFullComponent>(
                this.installService.concat(this.installPlugins).map(c => [c.name, {
                    name: c.name,
                    currentVersion: c.version
                }])
            );
            this.services.concat(this.plugins).forEach(c => {
                let component = full.get(c.name);
                if (!component) 
                {
                    component = { name: c.name, newVersion: c.version };
                }
                full.set(c.name, component);
            });

            servicesInstalled?.forEach(c => {
                let component = full.get(c.name);
                if (component) 
                {
                    component.newVersion = c.version;
                    full.set(c.name, component);
                }
            });

            this.fullComponents = Array.from(full.values());
        }
        catch (errors) {
            console.log("Error full component");
            console.log(errors);
            this.showMessage(translate('load_error'));
        }
        this.loading = false;
    },

    get getFullComponents(): Array<IFullComponent> {
        if (this.filter == FilterType.Update)
            return this.fullComponents.filter(f => f.newVersion && f.currentVersion)
        if (this.filter == FilterType.Install)
            return this.fullComponents.filter(f => !f.currentVersion)
        if (this.filter == FilterType.Delete)
            return this.fullComponents.filter(f => f.currentVersion)
        
        return this.fullComponents;
    },
});